import type { Environment, Tracker } from "@infinitaslearning/module-data-analyticstracker"
import { createTracker } from "@infinitaslearning/module-data-analyticstracker"
import { useMemo } from "react"
import { config } from "../config"
import type { IConfig } from "../config"
import { getBusinessUnit } from "../utils/business.utils"

export const createAnalyticsTracker = (config: IConfig) => {
  const environment: Environment = config.environment as Environment
  return createTracker({
    platform: "SEP",
    opCo: getBusinessUnit(),
    platformVersion: "1.2.3",
    environment: environment === "development" ? "acceptance" : environment
  })
}

export function useTracker() {
  const tracker = useMemo(() => createAnalyticsTracker(config), [])
  // Needed to use the tracker in the redux actions without passing it as a parameter
  window.tracker = tracker
  return tracker
}

declare global {
  interface Window {
    tracker?: Tracker
  }
}
